export default __webpack_public_path__ + "static/media/male.4648beb8.png";